import { FC } from 'react';

interface IContactOfficeCard {
  officeImg: string;
  name: string;
  address: string;
  country: string;
}

const ContactOfficeCard: FC<IContactOfficeCard> = ({ officeImg, name, address, country }) => {
  return (
    <div>
      <img
        src={officeImg}
        alt={`${name} office`}
        className="min-[320px]:text-center tw-mb-5 tw-w-[320px] sm:tw-mb-8 sm:tw-w-[380px] min-[1300px]:tw-w-[400px]"
      />
      <p className="tw-mb-2.5 tw-text-xl tw-font-semibold tw-text-white sm:tw-mb-4 sm:tw-text-2xl">{name}</p>
      <p className="tw-text-base tw-font-medium tw-leading-6 tw-text-skyBlue sm:tw-text-lg">{address}</p>
      <p className="tw-text-base tw-font-medium tw-leading-6 tw-text-skyBlue sm:tw-text-lg">{country}</p>
    </div>
  );
};

export default ContactOfficeCard;
